import {inject} from '@angular/core';
import {CanMatchFn, Route, Router, UrlSegment} from '@angular/router';
import { AuthService } from '../services/auth.service';

export const isProviderMatchGuard: CanMatchFn = (route: Route, segments: UrlSegment[]): boolean => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const currentUser = authService.getUser();

    if (currentUser && currentUser.roles.indexOf('PROVIDER') >= 0) {
        return true;
    } else {
        router.navigate(['/auth']).then();
        return false;
    }
};
